// extracted by mini-css-extract-plugin
module.exports = {"modal":"CategoryInfoModal_modal__uuJVw","content-container":"CategoryInfoModal_content-container__pDQf7","link":"CategoryInfoModal_link__1FDBK"};